import { DataVizContainerViewConfigWithStateManager } from '../../../common/types';
import {
  MultiMetricComparisonVizData,
  MultiMetricComparisonVizExternalProps,
} from '../../types';
import { multiMetricComparisonTableViewDataToUiComponentProps } from './dataToUiComponentProps';
import {
  MultiMetricComparisonTableViewActions,
  MultiMetricComparisonTableViewState,
  MultiMetricComparisonTableViewUiComponentProps,
} from './types';
import { MultiMetricComparisonTableViewUiComponent } from './UiComponent';
import { useMultiMetricComparisonTableViewStateManager } from './useStateManager';

export const multiMetricComparisonTableViewConfig: DataVizContainerViewConfigWithStateManager<
  MultiMetricComparisonVizData,
  MultiMetricComparisonVizExternalProps,
  MultiMetricComparisonTableViewUiComponentProps,
  MultiMetricComparisonTableViewState,
  MultiMetricComparisonTableViewActions
> = {
  hasStateManager: true,
  useStateManager: useMultiMetricComparisonTableViewStateManager,
  dataToUiComponentProps: multiMetricComparisonTableViewDataToUiComponentProps,
  UiComponent: MultiMetricComparisonTableViewUiComponent,
};
